module.exports = __webpack_public_path__ + "email.svg?0f0ab472924e8a5415e57aa3918d873f";